module.exports = __webpack_public_path__ + "img/2024-11-15d_2.25c6f083.jpg";